import { BaseEmptyPrefixControlBehaviour } from './BaseControlBehaviour';
/**
 * InputTrim - устанавливает на контрол с аттрибутом trim поведение, удаляющее пробельные символы с начала и конца строки.
 * Пробельными символами в этом контексте считаются все собственно пробельные символы (пробел, табуляция, неразрывный пробел и прочие) и все символы конца строки (LF, CR и прочие).
 * Применяется к элементам с типом input.
 */
export class InputTrimBehaviour extends BaseEmptyPrefixControlBehaviour {
    constructor() {
        super('inputtrim');
    }

    protected installCondition(element: any): boolean {
        return $(element).is('input');
    }

    protected installBehaviour(element: HTMLElement): void {
        $(element).change((e) => this.onInputChanged(e.currentTarget));
    }

    private onInputChanged(element: any) {
        const input = $(element);
        const trimmed = input.val().trim();
        input.val(trimmed);
    }
}

if(!window.Behaviours) window.Behaviours = {};
window.Behaviours.InputTrimBehaviour = InputTrimBehaviour;